/**
 * Linked maps whose server connection is currently unavailable (offline,
 * server restarting) but whose access has not been revoked.
 *
 * Their cached content is shown read-only until the channel reconnects and
 * the server confirms access again. Kept in its own module so the write
 * guards in node-operations.js can read it without importing crdt-bridge.js.
 */

const offlineDocIds = new Set();

export function markLinkedOffline(docId) {
  if (docId) offlineDocIds.add(docId);
}

export function clearLinkedOffline(docId) {
  offlineDocIds.delete(docId);
}

export function isLinkedOffline(docId) {
  return !!docId && offlineDocIds.has(docId);
}

export function resetLinkedOffline() {
  offlineDocIds.clear();
}
